import React, { useState } from 'react';
import { IPhotoAlbum } from '../../types/resources/PhotoAlbum';
import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { Swiper, SwiperSlide } from 'swiper/react';
import {Navigation, Pagination, EffectCoverflow, Virtual} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';


type TProps = {
    items: IPhotoAlbum[];
}

const Lightbox = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1;

    img {
        object-fit: contain !important;
        max-height: 100%;
        max-width: 100%;
    }
`;

function Gallery({ items }: TProps) {
    const [lightboxVisible, setLightboxVisible] = useState(false);
    const [currentImage, setCurrentImage] = useState<IPhotoAlbum>();

    // open lightbox
    const openLightbox = (item: IPhotoAlbum) => {
        setCurrentImage(item);
        setLightboxVisible(true);
    };

    // close lightbox
    const closeLightbox = () => {
        setLightboxVisible(false);
    };

    const hasItems = (items.length > 0);

    return hasItems ? (
        <>
            <Swiper
                className={'cr-my-xl'}
                modules={[Navigation, EffectCoverflow]} // Virtual
                navigation
                // virtual // NOTE: Virtual mode doesn't support decimal slides per view
                centeredSlides={true}
                effect="coverflow"
                coverflowEffect={{
                    // depth: 100,
                    // modifier: 1,
                    rotate: 0,
                    scale: 0.80,
                    // slideShadows: true,
                    stretch: 50,
                }}
                slidesPerView={1.4}
            >
                {items.map((item, index) => (
                    <SwiperSlide key={item.uri} virtualIndex={index} onClick={() => openLightbox(item)}>
                        <LazyLoadImage
                            className={'cr-aspect-video cr-rounded-block cr-w-100'}
                            alt={item.title}
                            src={item.uri}
                            placeholderSrc={item.thumbnailUri}
                            effect="blur"
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {lightboxVisible && (
                <Lightbox className={'cr-flex cr-center'} onClick={closeLightbox}>
                    <LazyLoadImage
                        className={'cr-aspect-video'}
                        alt={currentImage?.title}
                        src={currentImage?.uri}
                        placeholderSrc={currentImage?.thumbnailUri}
                        effect="blur"
                    />
                </Lightbox>
            )}
        </>
    ) : null;
}

export default Gallery;
